/*
 * throttledresize: special jQuery event that happens at a reduced rate compared to "resize"
 *
 * latest version and complete README available on Github:
 * https://github.com/louisremi/jquery-smartresize
 *
 * Copyright 2012 @louis_remi
 * Licensed under the MIT license.
 *
 * This saved you an hour of work? 
 * Send me music http://www.amazon.co.uk/wishlist/HNTU0468LQON
 */ (function($1) {
    var $event = $1.event, $special, dummy = {
        _: 0
    }, frame = 0, wasResized, animRunning;
    $special = $event.special.throttledresize = {
        setup: function() {
            $1(this).on("resize", $special.handler);
        },
        teardown: function() {
            $1(this).off("resize", $special.handler);
        },
        handler: function(event, execAsap) {
            var context = this, args = arguments;
            wasResized = true;
            if (!animRunning) {
                setInterval(function() {
                    frame++;
                    if (frame > $special.threshold && wasResized || execAsap) {
                        event.type = "throttledresize";
                        $event.dispatch.apply(context, args);
                        wasResized = false;
                        frame = 0;
                    }
                    if (frame > 9) {
                        $1(dummy).stop();
                        animRunning = false;
                        frame = 0;
                    }
                }, 30);
                animRunning = true;
            }
        },
        threshold: 0
    };
})(jQuery);
/*! jQuery Placeholder Enhanced 1.6.6 | @tdecs | under the MIT license */ (function(a, k) {
    var g = "placeholder" in k.createElement("input") && "placeholder" in k.createElement("textarea"), e = {
        cssClass: "placeholder",
        normalize: !0
    }, f = a.fn.val;
    g ? g && e.normalize && (a.fn.val = function() {
        var a = this[0];
        if (a) {
            if (arguments.length) !arguments[0] && a._placeholder && this.attr("placeholder", a._placeholder);
            else return a.value;
            this.toggleClass(e.cssClass, !arguments[0]);
            return f.apply(this, arguments);
        }
    }) : a.fn.val = function() {
        var b = this[0];
        if (b) {
            if (arguments.length || !a.nodeName(b, "input") && !a.nodeName(b, "textarea")) {
                if (!arguments[0] && this.attr("placeholder")) return b.value = this.addClass(e.cssClass).attr("placeholder"), this;
                this.removeClass(e.cssClass);
                return f.apply(this, arguments);
            }
            return b.value === this.attr("placeholder") ? "" : b.value;
        }
    };
    a.fn.placeholderEnhanced = function(b) {
        function k(p) {
            var c = {}, b = [
                "placeholder",
                "name",
                "id"
            ];
            a.each(p.attributes, function(p, d) {
                d.specified && 0 > a.inArray(d.name, b) && (c[d.name] = d.value);
            });
            return c;
        }
        function m(a) {
            a.css({
                position: "",
                left: ""
            });
        }
        function q(a) {
            a.css({
                position: "absolute",
                left: "-9999em"
            });
        }
        var d = a.extend(e, b);
        if (this.length && (!g || d.normalize)) return "destroy" === b ? this.filter(function() {
            return a.data(this, "placeholderEnhanced");
        }).removeClass(d.cssClass).each(function() {
            var d = a(this).unbind(".placeholder"), c = "password" === this.type, b = d.attr("placeholder");
            g ? delete this._placeholder : (this.value = this.value === b ? "" : this.value, c && (m(d), d.prev().unbind(".placeholder").remove()));
            a.fn.val = f;
            a.removeData(this, "placeholderEnhanced");
        }) : this.each(function() {
            if (!a.data(this, "placeholderEnhanced")) {
                var b = this, c = a(b), e = c.attr("placeholder"), f = "password" === b.type, l, h, n;
                g && d.normalize ? (l = function() {
                    b.value || c.addClass(d.cssClass).attr("placeholder", e);
                }, h = function() {
                    b._placeholder = e;
                    c.removeAttr("placeholder").removeClass(d.cssClass);
                }) : g || (l = function() {
                    c.val() ? c.val() && f && h() : f ? (m(n), q(c)) : c.val(e).addClass(d.cssClass);
                }, f ? (h = function() {
                    m(c);
                    q(n);
                }, n = a("<input>", a.extend(k(b), {
                    type: "text",
                    value: e,
                    tabindex: -1
                })).addClass(d.cssClass).bind("focus.placeholder", function() {
                    c.trigger("focus.placeholder");
                }).insertBefore(c)) : h = function() {
                    c.hasClass(d.cssClass) && (b.value = "", c.removeClass(d.cssClass));
                });
                c.bind("blur.placeholder", l).bind("focus.placeholder", h).trigger("blur.placeholder");
                a.data(b, "placeholderEnhanced", !0);
            }
        });
    };
    a(function() {
        a("input[placeholder], textarea[placeholder]").placeholderEnhanced();
    });
})(jQuery, document);
/*! Validatr - v0.5.1 - 2013-03-12
* http://jaymorrow.github.com/validatr/
* Copyright (c) 2013 Jay Morrow; Licensed MIT */ (function(t, e, a, r) {
    "use strict";
    function i(t, e) {
        if (this.el = t, this.$el = a(t), !this.$el.length || !this.$el.is("form")) throw Error("validatr needs a form to work.");
        this.isSubmit = !1, this.firstError = !1, this.options = a.extend({}, a.fn.validatr.defaultOptions, e), this.template = function(t) {
            var e = a(t.template).addClass("validatr-message");
            return t.theme.length ? e.addClass(w[t.theme] || t.theme) : e.css(k), e[0].outerHTML;
        }(this.options), this.option = function(t, e) {
            return arguments.length ? e === r ? this.options[t] === r ? null : this.options[t] : (this.options[t] = e, r) : a.extend({}, this.options);
        }, this.formElements = this.getElements(this.el).on("valid.validatr", a.proxy(f, this)).on("invalid.validatr", a.proxy(c, this)), this.el.noValidate = !0, this.$el.on("submit.validatr", a.proxy(m, this)), this.$el.on("reset.validatr", a.proxy(p, this));
    }
    function s() {
        this.formElements.on({
            "focus.validatrelement": o,
            "blur.validatrelement": l
        }), a("input[type=radio], input[type=checkbox]").on("click.validatrelement", function(t) {
            u(t.target);
        });
    }
    function n() {
        this.formElements.off(".validatrelement");
    }
    function o(t) {
        var e = t.target, r = a(e);
        "select" === e.nodeName.toLowerCase() && r.on("change.validatrinput", function() {
            setTimeout(function() {
                u(e);
            }, 1);
        }), r.on({
            "blur.validatrinput": function() {
                u(e);
            },
            "keyup.validatrinput": function(t) {
                e.value.length && -1 === a.inArray(E, t.keyCode) && u(e);
            }
        });
    }
    function l(t) {
        a(t.target).off(".validatrinput");
    }
    function u(t) {
        if ("radio" === t.type) {
            var r = a(e.getElementsByName(t.name)).filter("[required]");
            r.length && (t = r[0]);
        }
        var i = a(t), s = x.notInput.test(t.nodeName) ? t.nodeName.toLowerCase() : t.getAttribute("type"), n = v.attributes.required ? t.required : a(t).is("[required]"), o = {
            valid: !0,
            message: ""
        };
        if (v.inputtypes[s] ? (o.valid = t.validity.valid, o.message = t.validationMessage) : (n && (o = y.required(t)), o.valid && t.value.length && !x.boxes.test(s) && (t.pattern && (s = "pattern"), y[s] && (o = y[s](t)))), o.valid) {
            for(var l in b)if (b.hasOwnProperty(l) && i.is("[data-" + l + "]") && (o = b[l](t), !o.valid)) break;
        }
        return o.valid ? (i.trigger("valid"), !0) : (a.data(t, "validationMessage", o.message), i.trigger("invalid"), !1);
    }
    function d(t) {
        var e = !0;
        return t.each(function(t, a) {
            u(a) || (e = !1);
        }), e;
    }
    function m() {
        this.isSubmit = !0, p.call(this);
        var t = d(this.formElements);
        return t ? this.options.valid.call(this.el, this.el) : (s.call(this), this.isSubmit = !1, t);
    }
    function p() {
        n.call(this), this.firstError = !1, this.formElements.next(".validatr-message").remove();
    }
    function c(t) {
        if (!A) {
            t.preventDefault();
            var e = t.target, i = a(e), s = this.options, n = e.getAttribute("data-message") || a.data(e, "validationMessage"), o = a(this.template.replace("{{message}}", n));
            return this.isSubmit && !this.firstError ? (this.firstError = i.after(o), s.position.call(this, o, i), r) : ((!this.isSubmit || s.showall) && (f(t), i.after(o), s.position.call(this, o, i)), r);
        }
    }
    function f(t) {
        A || a(t.target).next(".validatr-message").remove();
    }
    function h(t, e) {
        t.css("position", "absolute");
        var a = e.offset(), r = e[0].getAttribute("data-location") || this.options.location;
        x.topbottom.test(r) ? (t.offset({
            left: a.left
        }), "top" === r && t.offset({
            top: a.top - t.outerHeight() - 2
        }), "bottom" === r && t.offset({
            top: a.top + t.outerHeight()
        })) : x.leftright.test(r) && (t.offset({
            top: a.top + e.outerHeight() / 2 - t.outerHeight() / 2
        }), "left" === r && t.offset({
            left: a.left - t.outerWidth() - 2
        }), "right" === r && t.offset({
            left: a.left + e.outerWidth() + 2
        }));
    }
    var v = function() {
        var t, a = {}, i = e.documentElement, s = e.createElement("input"), n = e.createElement("select"), o = e.createElement("textarea"), l = ":)", u = {}, d = {};
        return a.attributes = function(t) {
            for(var e = 0, a = t.length; a > e; e++)d[t[e]] = !!(t[e] in s);
            return d;
        }("max min multiple pattern required step".split(" ")), a.inputtypes = function(t) {
            for(var a, n, o, d = 0, m = t.length; m > d; d++)s.setAttribute("type", n = t[d]), a = "text" !== s.type, a && (s.value = l, s.style.cssText = "position:absolute;visibility:hidden;", /^range$/.test(n) && s.style.WebkitAppearance !== r ? (i.appendChild(s), o = e.defaultView, a = o.getComputedStyle && "textfield" !== o.getComputedStyle(s, null).WebkitAppearance && 0 !== s.offsetHeight, i.removeChild(s)) : /^(search|tel)$/.test(n) || (a = /^(url|email)$/.test(n) ? s.checkValidity && s.checkValidity() === !1 : s.value !== l)), u[t[d]] = !!a;
            return u;
        }("search tel url email datetime date month week time datetime-local number range color".split(" ")), function(r) {
            for(var i = 0, n = r.length; n > i; i++){
                t = s;
                try {
                    t.setAttribute("type", r[i]);
                } catch (o) {
                    t = e.createElement('<input type="' + r[i] + '">');
                }
                t.style.cssText = "position:absolute;visibility:hidden;", a.inputtypes[r[i]] = !!t.checkValidity;
            }
        }("text password radio checkbox".split(" ")), a.inputtypes.select = !!n.checkValidity, a.inputtypes.textarea = !!o.checkValidity, s = null, t = null, n = null, o = null, a;
    }(), g = function() {
        function t(t, e) {
            for(var a = -1, r = t ? t.length : 0; r > ++a;)if (t[a] === e) return a;
            return -1;
        }
        function e(e) {
            var i = e.getAttribute("data-format") || a.fn.validatr.defaultOptions.dateFormat, s = i.split(n.separatorsNoGroup), o = e.value.split(n.separatorsNoGroup), l = "yyyy-mm-dd".split("-"), u = i.replace(n.separators, "\\$1").replace("yyyy", n.dateParts.yyyy).replace("mm", n.dateParts.mm).replace("dd", n.dateParts.dd), d = -1, m = l.length, p = [];
            if (u = RegExp(u), !u.test(e.value)) return !1;
            for(; m > ++d;)p[d] = o[t(s, l[d])];
            return r(p.join("-"));
        }
        function r(t) {
            if (!s.isoDate.test(t)) return !1;
            var e = s.isoDate.exec(t);
            return new Date(parseInt(e[1], 10), parseInt(e[2], 10) - 1, parseInt(e[3], 10));
        }
        function i(t, e) {
            function r(t) {
                return 10 > t ? "0" + t : t;
            }
            var i = r(t.getDate()), s = r(t.getMonth() + 1), n = t.getFullYear(), o = (e.getAttribute("data-format") || a.fn.validatr.defaultOptions.dateFormat).replace("mm", s).replace("yyyy", n).replace("dd", i);
            return o;
        }
        var s = {
            isoDate: /^(\d{4})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
        }, n = {
            separators: /(\/|\-|\.)/g,
            separatorsNoGroup: /\/|\-|\./g,
            dateParts: {
                dd: "(0[1-9]|[12][0-9]|3[01])",
                mm: "(0[1-9]|1[012])",
                yyyy: "(\\d{4})"
            }
        };
        return {
            formatISODate: i,
            parseDate: e,
            parseISODate: r
        };
    }(), y = function() {
        var t = {
            color: /^#[0-9A-F]{6}$/i,
            email: /^[a-zA-Z0-9.!#$%&’*+\/=?\^_`{|}~\-]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*$/,
            isoDate: /^(\d{4})-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/,
            number: /^-?\d*\.?\d*$/,
            time: /^([01][0-9]|2[0-3])(:([0-5][0-9])){2}$/,
            url: /^\s*https?:\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?\s*$/
        }, i = {
            boxes: /checkbox|radio/i,
            spaces: /,\s*/
        }, s = function(t, e, r, i, s) {
            var n = !0, o = a.validatr.messages.range.base, l = e, u = r;
            return "date" === s && (l = e && g.formatISODate(e, this), u = r && g.formatISODate(r, this)), t !== !1 && (i !== !1 && (n = "any" === i ? !0 : 0 === (t - e) % i, o = a.validatr.messages.range.invalid), n && (e !== !1 && r !== !1 ? (n = t >= e && r >= t, o = a.validatr.messages.range.overUnder) : e !== !1 ? (n = t >= e, o = a.validatr.messages.range.overflow) : r !== !1 && (n = r >= t, o = a.validatr.messages.range.underflow))), {
                valid: t !== !1 && n,
                message: o.replace("{{type}}", s).replace("{{min}}", l).replace("{{max}}", u)
            };
        };
        return {
            checkbox: function(t) {
                return {
                    valid: t.checked,
                    message: a.validatr.messages.checkbox
                };
            },
            color: function(e) {
                return {
                    valid: t.color.test(e.value),
                    message: a.validatr.messages.color
                };
            },
            date: function(t) {
                var e = a(t), r = v.inputtypes.date ? g.parseISODate(t.value) : g.parseDate(t), i = e.attr("min") ? g.parseISODate(e.attr("min")) : !1, n = e.attr("max") ? g.parseISODate(e.attr("max")) : !1, o = !1;
                return s.call(t, r, i, n, o, "date");
            },
            email: function(e) {
                var s = !0, n = a.validatr.messages.email.single, o = v.attributes.multiple ? e.multiple : a(e).is("[multiple]");
                if (o) {
                    var l = e.value.split(i.spaces);
                    a.each(l, function(e, i) {
                        return t.email.test(i) ? r : (s = !1, n = a.validatr.messages.email.multiple, r);
                    });
                } else s = t.email.test(e.value);
                return {
                    valid: s,
                    message: n
                };
            },
            number: function(e) {
                var a = e.value.replace(",", ""), r = (t.number.test(a) && parseFloat(a), t.number.test(e.getAttribute("min")) ? parseFloat(e.getAttribute("min")) : !1), i = t.number.test(e.getAttribute("max")) ? parseFloat(e.getAttribute("max")) : !1, n = t.number.test(e.getAttribute("step")) ? parseFloat(e.getAttribute("step")) : "any" === e.getAttribute("step") ? "any" : !1;
                return (n === !1 || 0 >= n) && (n = 1), s.call(e, a, r, i, n, "number");
            },
            pattern: function(t) {
                return {
                    valid: RegExp(t.getAttribute("pattern")).test(t.value),
                    message: a.validatr.messages.pattern
                };
            },
            radio: function(t) {
                return {
                    valid: a(e.getElementsByName(t.name)).is(":checked"),
                    message: a.validatr.messages.radio
                };
            },
            range: function(t) {
                return this.number(t);
            },
            required: function(t) {
                return i.boxes.test(t.type) ? this[t.type](t) : {
                    valid: !!t.value.length,
                    message: "select" === t.nodeName.toLowerCase() ? a.validatr.messages.select : a.validatr.messages.required
                };
            },
            time: function(e) {
                return {
                    valid: t.time.test(e.value),
                    message: a.validatr.messages.time
                };
            },
            url: function(e) {
                return {
                    valid: t.url.test(e.value),
                    message: a.validatr.messages.url
                };
            }
        };
    }(), b = function() {
        function t(t) {
            if ("text" !== t.type) throw Error("element must have a type of text");
            var e = t.getAttribute("data-as");
            return y[e] ? y[e](t) : r;
        }
        function i(t) {
            var r = t.getAttribute("data-match"), i = e.getElementById(r) || e.getElementsByName(r)[0];
            return i ? (a(i).off("valid.validatrinput").on("valid.validatrinput", function() {
                t.value === i.value && u(t);
            }), {
                valid: t.value === i.value,
                message: "'" + t.name + "' does not equal '" + i.name + "'"
            }) : {
                valid: !1,
                message: "'" + r + "' can not be found"
            };
        }
        return {
            as: t,
            match: i
        };
    }(), x = {
        boxes: /checkbox|radio/i,
        leftright: /left|right/i,
        notInput: /select|textarea/i,
        topbottom: /top|bottom/i
    }, E = [
        16,
        17,
        18,
        19,
        20,
        33,
        34,
        35,
        36,
        37,
        39
    ], w = {
        bootstrap: "alert alert-error",
        jqueryui: "ui-state-error ui-corner-all"
    }, k = {
        color: "#f0444d",
        backgroundColor: "#ffcbcb",
        border: "1px solid #e4a6af",
        padding: "2px 6px",
        borderRadius: "2px"
    }, A = !1, q = function() {};
    q.prototype = {
        addTest: function(t) {
            var e = "string" != typeof t, r = Array.prototype.slice.call(arguments, 1)[0];
            if (e) a.extend(b, t);
            else {
                if (!r) throw Error("You must include a callback function");
                b[t] = r;
            }
        },
        getElements: function(t) {
            if (this.formElements) return this.formElements;
            var e = a(t).map(function() {
                return a.makeArray(this.elements);
            }).not("fieldset, button, input[type=submit], input[type=button], input[type=reset]");
            return t.id && (e = e.add(a('[form="' + t.id + '"]'))), e;
        },
        validateElement: function(t) {
            if (!t) throw Error("method requires an element");
            A = !0;
            var e = u(t[0] || t);
            return A = !1, e;
        },
        validateForm: function(t) {
            var e, a = this.el || (t instanceof jQuery ? t[0] : t);
            if ("form" !== a.nodeName.toLowerCase()) throw Error("you must pass a form to this method");
            return A = !0, e = d(this.formElements || this.getElements(a)), A = !1, e;
        }
    }, a.fn.validatr = function(t) {
        var e, s = "string" == typeof t, n = Array.prototype.slice.call(arguments, 1), o = this;
        if (s) this.each(function() {
            var i;
            if (e = a.data(this, "validatr"), !e) throw Error("cannot call methods on validatr prior to initialization; attempted to call method '" + t + "'");
            if (!a.isFunction(e[t])) throw Error("no such method '" + t + "' for validatr instance");
            return i = e[t].apply(e, n), i !== e && i !== r ? (o = i && i.jquery ? o.pushStack(i.get()) : i, !1) : r;
        });
        else {
            var l;
            this.each(function() {
                e = a.data(this, "validatr"), e || (l = new q, i.call(l, this, t || {}), a.data(this, "validatr", l));
            });
        }
        return o;
    }, a.fn.validatr.defaultOptions = {
        dateFormat: "yyyy-mm-dd",
        location: "right",
        position: h,
        showall: !1,
        template: "<div>{{message}}</div>",
        theme: "",
        valid: a.noop
    }, a.validatr = new q, a.validatr.messages = {
        checkbox: "Please check this box if you want to proceed.",
        color: "Please enter a color in the format #xxxxxx",
        email: {
            single: "Please enter an email address.",
            multiple: "Please enter a comma separated list of email addresses."
        },
        pattern: "Please match the requested format.",
        radio: "Please select one of these options.",
        range: {
            base: "Please enter a {{type}}",
            overflow: "Please enter a {{type}} greater than or equal to {{min}}.",
            overUnder: "Please enter a {{type}} greater than or equal to {{min}}<br> and less than or equal to {{max}}.",
            invalid: "Invalid {{type}}",
            underflow: "Please enter a {{type}} less than or equal to {{max}}."
        },
        required: "Please fill out this field.",
        select: "Please select an item in the list.",
        time: "Please enter a time in the format hh:mm:ss",
        url: "Please enter a url."
    }, a.validatr.debug = function() {
        if (!QUnit) throw Error("QUnit is required for debugging");
        this.Support = v, this.Tests = y, this.CustomTests = b, this.Format = g;
    }, a.expr[":"].validatr = function(t) {
        return !!a.data(t, "validatr");
    };
})(this, this.document, jQuery);
/*! Superslides - v0.6.3-wip - 2013-08-01
* https://github.com/nicinabox/superslides
* Copyright (c) 2013 Nic Aitch; Licensed MIT */ (function(window1, $1) {
    var Superslides, plugin = 'superslides';
    Superslides = function(el, options) {
        this.options = $1.extend({
            play: 7000,
            animation_speed: 1000,
            animation_easing: 'swing',
            animation: 'slide',
            inherit_width_from: window1,
            inherit_height_from: window1,
            pagination: true,
            hashchange: false,
            scrollable: true,
            elements: {
                preserve: '.preserve',
                nav: '.slides-navigation',
                container: '.slides-container',
                pagination: '.slides-pagination'
            }
        }, options);
        var that = this, $control = $1('<div>', {
            "class": 'slides-control'
        }), multiplier = 1;
        this.$el = $1(el);
        this.$container = this.$el.find(this.options.elements.container);
        var initialize = function() {
            multiplier = that._findMultiplier();
            that.$el.on('click', that.options.elements.nav + " a", function(e) {
                e.preventDefault();
                that.stop();
                if ($1(this).hasClass('next')) that.animate('next', function() {
                    that.start();
                });
                else that.animate('prev', function() {
                    that.start();
                });
            });
            $1(document).on('keyup', function(e) {
                if (e.keyCode === 37) that.animate('prev');
                if (e.keyCode === 39) that.animate('next');
            });
            $1(window1).on('resize', function() {
                setTimeout(function() {
                    var $children = that.$container.children();
                    that.width = that._findWidth();
                    that.height = that._findHeight();
                    $children.css({
                        width: that.width,
                        left: that.width
                    });
                    that.css.containers();
                    that.css.images();
                }, 10);
            });
            $1(window1).on('hashchange', function() {
                var hash = that._parseHash(), index;
                if (hash && !isNaN(hash)) index = that._upcomingSlide(hash - 1);
                else index = that._upcomingSlide(hash);
                if (index >= 0 && index !== that.current) that.animate(index);
            });
            that.pagination._events();
            that.start();
            return that;
        };
        var css = {
            containers: function() {
                if (that.init) {
                    that.$el.css({
                        height: that.height
                    });
                    that.$control.css({
                        width: that.width * multiplier,
                        left: -that.width
                    });
                    that.$container.css({});
                } else {
                    $1('body').css({
                        margin: 0
                    });
                    that.$el.css({
                        position: 'fixed',
                        overflow: 'hidden',
                        width: '100%',
                        height: that.height
                    });
                    that.$control.css({
                        position: 'relative',
                        transform: 'translate3d(0)',
                        height: '100%',
                        width: that.width * multiplier,
                        left: -that.width
                    });
                    that.$container.css({
                        display: 'none',
                        margin: '0',
                        padding: '0',
                        listStyle: 'none',
                        position: 'relative',
                        height: '100%'
                    });
                }
                if (that.size() === 1) that.$el.find(that.options.elements.nav).hide();
            },
            images: function() {
                var $images = that.$container.find('img').not(that.options.elements.preserve);
                $images.removeAttr('width').removeAttr('height').css({
                    "-webkit-backface-visibility": 'hidden',
                    "-ms-interpolation-mode": 'bicubic',
                    "position": 'absolute',
                    "left": '0',
                    "top": '0',
                    "z-index": '-1',
                    "max-width": 'none'
                });
                $images.each(function() {
                    var image_aspect_ratio = that.image._aspectRatio(this), image = this;
                    if (!$1.data(this, 'processed')) {
                        var img = new Image();
                        img.onload = function() {
                            that.image._scale(image, image_aspect_ratio);
                            that.image._center(image, image_aspect_ratio);
                            $1.data(image, 'processed', true);
                        };
                        img.src = this.src;
                    } else {
                        that.image._scale(image, image_aspect_ratio);
                        that.image._center(image, image_aspect_ratio);
                    }
                });
            },
            children: function() {
                var $children = that.$container.children();
                if ($children.length == 1) that.options.play = false;
                if ($children.is('img')) {
                    $children.each(function() {
                        if ($1(this).is('img')) {
                            $1(this).wrap('<div>');
                            var id = $1(this).attr('id');
                            $1(this).removeAttr('id');
                            $1(this).parent().attr('id', id);
                        }
                    });
                    $children = that.$container.children();
                }
                if (!that.init) $children.css({
                    display: 'none',
                    left: that.width * 2
                });
                $children.css({
                    position: 'absolute',
                    overflow: 'hidden',
                    height: '100%',
                    width: that.width,
                    top: 0,
                    zIndex: 0
                });
            }
        };
        var fx = {
            slide: function(orientation, complete) {
                var $children = that.$container.children(), $target = $children.eq(orientation.upcoming_slide);
                $target.css({
                    left: orientation.upcoming_position,
                    display: 'block'
                });
                that.$control.animate({
                    left: orientation.offset
                }, that.options.animation_speed, that.options.animation_easing, function() {
                    if (that.size() > 1) {
                        that.$control.css({
                            left: -that.width
                        });
                        $children.eq(orientation.upcoming_slide).css({
                            left: that.width,
                            zIndex: 2
                        });
                        if (orientation.outgoing_slide >= 0) $children.eq(orientation.outgoing_slide).css({
                            left: that.width,
                            display: 'none',
                            zIndex: 0
                        });
                    }
                    complete();
                });
            },
            fade: function(orientation, complete) {
                var that = this, $children = that.$container.children(), $outgoing = $children.eq(orientation.outgoing_slide), $target = $children.eq(orientation.upcoming_slide);
                $target.css({
                    left: this.width,
                    opacity: 1,
                    display: 'block'
                });
                if (orientation.outgoing_slide >= 0) $outgoing.animate({
                    opacity: 0
                }, that.options.animation_speed, that.options.animation_easing, function() {
                    if (that.size() > 1) {
                        $children.eq(orientation.upcoming_slide).css({
                            zIndex: 2
                        });
                        if (orientation.outgoing_slide >= 0) $children.eq(orientation.outgoing_slide).css({
                            opacity: 1,
                            display: 'none',
                            zIndex: 0
                        });
                    }
                    complete();
                });
                else {
                    $target.css({
                        zIndex: 2
                    });
                    complete();
                }
            }
        };
        fx = $1.extend(fx, $1.fn.superslides.fx);
        var image = {
            _centerY: function(image) {
                var $img = $1(image);
                $img.css({
                    top: (that.height - $img.height()) / 2
                });
            },
            _centerX: function(image) {
                var $img = $1(image);
                $img.css({
                    left: (that.width - $img.width()) / 2
                });
            },
            _center: function(image) {
                that.image._centerX(image);
                that.image._centerY(image);
            },
            _aspectRatio: function(image) {
                if (!image.naturalHeight && !image.naturalWidth) {
                    var img = new Image();
                    img.src = image.src;
                    image.naturalHeight = img.height;
                    image.naturalWidth = img.width;
                }
                return image.naturalHeight / image.naturalWidth;
            },
            _scale: function(image, image_aspect_ratio) {
                image_aspect_ratio = image_aspect_ratio || that.image._aspectRatio(image);
                var container_aspect_ratio = that.height / that.width, $img = $1(image);
                if (container_aspect_ratio > image_aspect_ratio) $img.css({
                    height: that.height,
                    width: that.height / image_aspect_ratio
                });
                else $img.css({
                    height: that.width * image_aspect_ratio,
                    width: that.width
                });
            }
        };
        var pagination = {
            _setCurrent: function(i) {
                if (!that.$pagination) return;
                var $pagination_children = that.$pagination.children();
                $pagination_children.removeClass('current');
                $pagination_children.eq(i).addClass('current');
            },
            _addItem: function(i) {
                var slide_number = i + 1, href = slide_number, $slide = that.$container.children().eq(i), slide_id = $slide.attr('id');
                if (slide_id) href = slide_id;
                var $item = $1("<a>", {
                    'href': "#" + href,
                    'text': href
                });
                $item.appendTo(that.$pagination);
            },
            _setup: function() {
                if (!that.options.pagination || that.size() === 1) return;
                var $pagination = $1("<nav>", {
                    'class': that.options.elements.pagination.replace(/^\./, '')
                });
                that.$pagination = $pagination.appendTo(that.$el);
                for(var i = 0; i < that.size(); i++)that.pagination._addItem(i);
            },
            _events: function() {
                that.$el.on('click', that.options.elements.pagination + ' a', function(e) {
                    e.preventDefault();
                    var hash = that._parseHash(this.hash), index = that._upcomingSlide(hash - 1);
                    if (index !== that.current) that.animate(index, function() {
                        that.start();
                    });
                });
            }
        };
        this.css = css;
        this.image = image;
        this.pagination = pagination;
        this.fx = fx;
        this.animation = this.fx[this.options.animation];
        this.$control = this.$container.wrap($control).parent('.slides-control');
        that._findPositions();
        that.width = that._findWidth();
        that.height = that._findHeight();
        this.css.children();
        this.css.containers();
        this.css.images();
        this.pagination._setup();
        return initialize();
    };
    Superslides.prototype = {
        _findWidth: function() {
            return $1(this.options.inherit_width_from).width();
        },
        _findHeight: function() {
            return $1(this.options.inherit_height_from).height();
        },
        _findMultiplier: function() {
            return this.size() === 1 ? 1 : 3;
        },
        _upcomingSlide: function(direction) {
            if (/next/.test(direction)) return this._nextInDom();
            else if (/prev/.test(direction)) return this._prevInDom();
            else if (/\d/.test(direction)) return +direction;
            else if (direction && /\w/.test(direction)) {
                var index = this._findSlideById(direction);
                if (index >= 0) return index;
                else return 0;
            } else return 0;
        },
        _findSlideById: function(id) {
            return this.$container.find('#' + id).index();
        },
        _findPositions: function(current, thisRef) {
            thisRef = thisRef || this;
            if (current === undefined) current = -1;
            thisRef.current = current;
            thisRef.next = thisRef._nextInDom();
            thisRef.prev = thisRef._prevInDom();
        },
        _nextInDom: function() {
            var index = this.current + 1;
            if (index === this.size()) index = 0;
            return index;
        },
        _prevInDom: function() {
            var index = this.current - 1;
            if (index < 0) index = this.size() - 1;
            return index;
        },
        _parseHash: function(hash) {
            hash = hash || window1.location.hash;
            hash = hash.replace(/^#/, '');
            if (hash && !isNaN(+hash)) hash = +hash;
            return hash;
        },
        size: function() {
            return this.$container.children().length;
        },
        destroy: function() {
            return this.$el.removeData();
        },
        update: function() {
            this.css.children();
            this.css.containers();
            this.css.images();
            this.pagination._addItem(this.size());
            this._findPositions(this.current);
            this.$el.trigger('updated.slides');
        },
        stop: function() {
            clearInterval(this.play_id);
            delete this.play_id;
            this.$el.trigger('stopped.slides');
        },
        start: function() {
            var that = this;
            if (that.options.hashchange) $1(window1).trigger('hashchange');
            else this.animate();
            if (this.options.play) {
                if (this.play_id) this.stop();
                this.play_id = setInterval(function() {
                    that.animate();
                }, this.options.play);
            }
            this.$el.trigger('started.slides');
        },
        animate: function(direction, userCallback) {
            var that = this, orientation = {};
            if (this.animating) return;
            this.animating = true;
            if (direction === undefined) direction = 'next';
            orientation.upcoming_slide = this._upcomingSlide(direction);
            if (orientation.upcoming_slide >= this.size()) return;
            orientation.outgoing_slide = this.current;
            orientation.upcoming_position = this.width * 2;
            orientation.offset = -orientation.upcoming_position;
            if (direction === 'prev' || direction < orientation.outgoing_slide) {
                orientation.upcoming_position = 0;
                orientation.offset = 0;
            }
            if (that.size() > 1) that.pagination._setCurrent(orientation.upcoming_slide);
            if (that.options.hashchange) {
                var hash = orientation.upcoming_slide + 1, id = that.$container.children(':eq(' + orientation.upcoming_slide + ')').attr('id');
                if (id) window1.location.hash = id;
                else window1.location.hash = hash;
            }
            that.$el.trigger('animating.slides', [
                orientation
            ]);
            that.animation(orientation, function() {
                that._findPositions(orientation.upcoming_slide, that);
                if (typeof userCallback === 'function') userCallback();
                that.animating = false;
                that.$el.trigger('animated.slides');
                if (!that.init) {
                    that.$el.trigger('init.slides');
                    that.init = true;
                    that.$container.fadeIn('fast');
                }
            });
        }
    };
    $1.fn[plugin] = function(option, args) {
        var result = [];
        this.each(function() {
            var $this, data, options;
            $this = $1(this);
            data = $this.data(plugin);
            options = typeof option === 'object' && option;
            if (!data) result = $this.data(plugin, data = new Superslides(this, options));
            if (typeof option === "string") {
                result = data[option];
                if (typeof result === 'function') return result = result.call(data, args);
            }
        });
        return result;
    };
    $1.fn[plugin].fx = {};
})(this, jQuery);
(function($1) {
    var level = [];
    var lastclicked = [];
    $1.fn.popup = $1.fn.popup = function(customoptions) {
        var $body = $1('body'), $window = $1(window), $document = $1(document), $el, $newel, $wrapper, options = {}, blurhandler, focushandler, defaults = {
            type: 'overlay',
            action: 'click',
            background: true,
            color: 'black',
            opacity: '0.4',
            horizontal: 'center',
            vertical: 'center',
            escape: true,
            blur: false,
            fade: 250,
            opensufix: '_open',
            closesufix: '_close',
            keepfocus: true,
            reposition: false,
            autozindex: false
        };
        var init = function(el) {
            if (!$1(el).attr('id')) $1(el).attr('id', 'j-popup-' + parseInt(Math.random() * 100000000));
            lastclicked[el.id] = false;
            level[el.id] = 0;
            $el = $1(el);
            options = $1.extend({}, defaults, customoptions);
            if (options.reposition === true) {
                $newel = $el;
                $el = $wrapper = $1('#' + el.id + '_wrapper');
                positionpopup(el);
                return false;
            }
            if ($el.attr('data-popup-initialized')) return false;
            $el.attr('data-popup-initialized', 'true');
            var triggerelement = '.' + el.id + options.opensufix;
            if (options.type == 'tooltip') {
                options.background = false;
                options.keepfocus = false;
            }
            $el.css({
                display: 'none'
            });
            $body.prepend(el);
            if (options.background && !$1('#' + el.id + '_background').length) {
                var popupback = '<div id="' + el.id + '_background" class="popup_background"></div>';
                $body.prepend(popupback);
                $1('#' + el.id + '_background').css({
                    backgroundColor: options.color,
                    opacity: options.opacity,
                    position: 'fixed',
                    top: '0',
                    right: '0',
                    bottom: '0',
                    left: '0',
                    display: 'none'
                });
            }
            if (options.type == 'overlay') {
                $el.css({
                    display: 'inline-block',
                    textAlign: 'left',
                    position: 'relative',
                    verticalAlign: 'middle'
                }).addClass('popup_content');
                $el.wrap('<div id="' + el.id + '_wrapper" class="popup_wrapper" />');
                $wrapper = $1('#' + el.id + '_wrapper');
                $wrapper.css({
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    display: 'none',
                    textAlign: 'center'
                });
                $wrapper.append('<div class="popup_align" />');
                $1('.popup_align').css({
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%'
                });
                if (options.horizontal == 'right') $wrapper.css('text-align', 'right');
                else if (options.horizontal == 'left') $wrapper.css('text-align', 'left');
                if (options.vertical == 'bottom') $el.css('vertical-align', 'bottom');
                else if (options.vertical == 'top') $el.css('vertical-align', 'top');
                $newel = $el;
                $el = $wrapper;
            }
            $1(triggerelement).each(function(i, item) {
                $1(item).attr('data-popup-order', i);
            });
            if (options.action == 'click') {
                $1(triggerelement).on('click', function(e) {
                    if ($el.is(':hidden')) {
                        var or = $1(this).attr('data-popup-order');
                        dopopup(el, or);
                        e.preventDefault();
                    }
                });
                $1('.' + el.id + options.closesufix).click(function(e) {
                    hidePopUp(el);
                    e.preventDefault();
                });
            } else if (options.action == 'hover') {
                $1(triggerelement).mouseenter(function() {
                    dopopup(el, $1(this).attr('data-popup-order'));
                });
                $1(triggerelement).mouseleave(function() {
                    hidePopUp(el);
                });
            } else {
                $1(triggerelement).mouseover(function() {
                    dopopup(el, $1(this).attr('data-popup-order'));
                });
                $1(triggerelement).mouseout(function() {
                    hidePopUp(el);
                });
            }
            if (options.escape) $1(document).keydown(function(e) {
                if (e.keyCode == 27 && $el.css('display') == 'block') hidePopUp(el);
            });
            $1(window).bind('resize', function() {
                if (options.type != 'tooltip') positionpopup(el);
            });
            if (options.autozindex === true) {
                var elements = document.getElementsByTagName("*"), len = elements.length, maxZIndex = 0;
                for(var i = 0; i < len; i++){
                    var elementZIndex = $1(elements[i]).css("z-index");
                    if (elementZIndex !== "auto") {
                        elementZIndex = parseInt(elementZIndex);
                        if (maxZIndex < elementZIndex) maxZIndex = elementZIndex;
                    }
                }
                level[el.id] = maxZIndex;
                if (level[el.id] > 0) $el.css({
                    zIndex: level[el.id] + 2
                });
                if (options.background) {
                    if (level[el.id] > 0) $1('#' + el.id + '_background').css({
                        zIndex: level[el.id] + 1
                    });
                }
            }
            if (options.autoopen) dopopup(el, 0);
        };
        var dopopup = function(el, order) {
            var clickplace = order;
            callback(options.beforeopen, clickplace);
            lastclicked[el.id] = clickplace;
            if (options.fade) $el.fadeIn(options.fade, function() {
                $1(document).on('click', blurhandler);
                $1(document).on('focusin', focushandler);
            });
            else {
                $el.show();
                setTimeout(function() {
                    $1(document).on('click', blurhandler);
                    $1(document).on('focusin', focushandler);
                }, 0);
            }
            positionpopup(el, clickplace);
            if (options.background) {
                if (options.fade) $1('#' + el.id + '_background').fadeIn(options.fade);
                else $1('#' + el.id + '_background').show();
            }
            if (options.keepfocus) {
                $newel.attr('tabindex', -1).focus();
                focushandler = function(e) {
                    if (!$1(e.target).parents().andSelf().is('#' + el.id)) $newel.focus();
                };
            }
            setTimeout(function() {
                window.scrollTo(document.body.scrollLeft, document.body.scrollTop);
            }, 0);
            callback(options.onOpen, clickplace);
            if (options.blur) blurhandler = function(e) {
                if (!$1(e.target).parents().andSelf().is('#' + el.id)) hidePopUp(el);
            };
        };
        var positionpopup = function(el, clickplace) {
            clickplace = clickplace || 0;
            if (options.type == 'tooltip') {
                $el.css({
                    'position': 'absolute'
                });
                var $link = $1('.' + el.id + options.opensufix + '[data-popup-order="' + clickplace + '"]');
                var linkOffset = $link.offset();
                if (options.horizontal == 'right') $el.css('left', linkOffset.left + $link.outerWidth());
                else if (options.horizontal == 'left') $el.css('right', $1(window).width() - linkOffset.left);
                else $el.css('left', linkOffset.left + $link.outerWidth() / 2 - $1(el).outerWidth() / 2 - parseFloat($1(el).css('marginLeft')));
                if (options.vertical == 'bottom') $el.css('top', linkOffset.top + $link.outerHeight());
                else if (options.vertical == 'top') $el.css('bottom', $1(window).height() - linkOffset.top);
                else $el.css('top', linkOffset.top + $link.outerHeight() / 2 - $1(el).outerHeight() / 2 - parseFloat($1(el).css('marginTop')));
            } else if (options.type == 'overlay') {
                if ($window.height() < $newel.outerHeight() + parseFloat($newel.css('marginTop')) + parseFloat($newel.css('marginBottom'))) $el.css({
                    position: 'absolute',
                    top: $window.scrollTop()
                });
                else $el.css({
                    position: 'fixed',
                    top: '0'
                });
            }
        };
        var hidePopUp = function(el) {
            if (options.background) {
                if (options.fade) $1('#' + el.id + '_background').fadeOut(options.fade);
                else $1('#' + el.id + '_background').hide();
            }
            if (options.blur) $1(document).off('click', blurhandler);
            if (options.keepfocus) {
                $1(document).off('focusin', focushandler);
                $1('.' + el.id + options.opensufix).focus();
            }
            if (options.fade) $el.fadeOut(options.fade);
            else $el.hide();
            callback(options.onClose, lastclicked[el.id]);
        };
        var callback = function(func, clickplace) {
            var cp = $1('.' + $el.attr('id') + options.opensufix + '[data-popup-order="' + clickplace + '"]');
            if (typeof func == 'function') func(cp);
        };
        this.each(function() {
            init(this);
        });
        return hidePopUp;
    };
})(jQuery);
/*
 * jQuery The Final Countdown plugin v2.0.0
 * http://github.com/hilios/jquery.countdown
 * Copyright (c) 2011 Edson Hilios
 */ !function(a) {
    "function" == typeof define && define.amd ? define([
        "jquery"
    ], a) : a(jQuery);
}(function(a) {
    function b(a) {
        if (a instanceof Date) return a;
        if (String(a).match(g)) return String(a).match(/^[0-9]*$/) && (a = Number(a)), new Date(a);
        throw new Error("Couldn't cast `" + a + "` to a date object.");
    }
    function c(a) {
        return function(b) {
            var c = b.match(/%(-|!)?[A-Z]{1,}(:[^;]+;)?/gi);
            if (c) for(var e = 0, f = c.length; f > e; ++e){
                var g = c[e].match(/%(-|!)?([a-zA-Z]+)(:[^;]+;)?/), i = new RegExp(g[0]), j = g[1] || "", k = g[3] || "", l = null;
                g = g[2], h.hasOwnProperty(g) && (l = h[g], l = Number(a[l])), a.hasOwnProperty(g) && (l = Number(a[g])), null !== l && ("!" === j && (l = d(k, l)), "" === j && 10 > l && (l = "0" + l.toString()), b = b.replace(i, l.toString()));
            }
            return b = b.replace(/%%/, "%");
        };
    }
    function d(a, b) {
        var c = "s", d = "";
        return a && (a = a.replace(/(:|;|\s)/gi, "").split(/\,/), 1 === a.length ? c = a[0] : (d = a[0], c = a[1])), 1 === Math.abs(b) ? d : c;
    }
    var e = 100, f = {}, g = [];
    g.push(/^[0-9]*$/.source), g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), g.push(/[0-9]{4}(\/[0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), g = new RegExp(g.join("|"));
    var h = {
        Y: "years",
        m: "months",
        w: "weeks",
        d: "days",
        D: "totalDays",
        H: "hours",
        M: "minutes",
        S: "seconds"
    }, i = function(b, c, d) {
        this.el = b, this.$el = a(b), this.interval = null, this.offset = {}, this.setFinalDate(c), d && (this.$el.on("update.countdown", d), this.$el.on("stoped.countdown", d), this.$el.on("finish.countdown", d)), this.start();
    };
    a.extend(i.prototype, {
        start: function() {
            if (null !== this.interval) throw new Error("Countdown is already running!");
            var a = this;
            this.update(), this.interval = setInterval(function() {
                a.update.call(a);
            }, e);
        },
        stop: function() {
            clearInterval(this.interval), this.interval = null, this.dispatchEvent("stoped");
        },
        pause: function() {
            this.stop.call(this);
        },
        resume: function() {
            this.start.call(this);
        },
        remove: function() {
            this.stop(), delete f[this.el];
        },
        setFinalDate: function(a) {
            this.finalDate = b(a);
        },
        update: function() {
            return 0 === this.$el.closest("html").length ? (this.remove(), void 0) : (this.totalSecsLeft = this.finalDate.valueOf() - (new Date).valueOf(), this.totalSecsLeft = Math.ceil(this.totalSecsLeft / 1e3), this.totalSecsLeft = this.totalSecsLeft < 0 ? 0 : this.totalSecsLeft, this.offset = {
                seconds: this.totalSecsLeft % 60,
                minutes: Math.floor(this.totalSecsLeft / 60) % 60,
                hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
                totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
                weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
                months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30),
                years: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 365)
            }, 0 === this.totalSecsLeft ? (this.stop(), this.dispatchEvent("finish")) : this.dispatchEvent("update"), void 0);
        },
        dispatchEvent: function(b) {
            var d = a.Event(b + ".countdown");
            d.finalDate = this.finalDate, d.offset = a.extend({}, this.offset), d.offsetDate = new Date(this.totalSecsLeft), d.strftime = c(this.offset), this.$el.trigger(d);
        }
    }), a.fn.countdown = function() {
        var b = Array.prototype.slice.call(arguments, 0);
        return this.each(function() {
            if (f.hasOwnProperty(this)) {
                var c = b[0];
                i.prototype.hasOwnProperty(c) ? f[this][c].apply(f[this], b.slice(1)) : null === c.match(/^[$A-Z_][0-9A-Z_$]*$/i) ? f[this].setFinalDate.call(f[this], c) : a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, c));
            } else f[this] = new i(this, b[0], b[1]);
        });
    };
});
(function($1) {
    $1.fn.twittie = function(options) {
        var settings = $1.extend({
            'count': 10,
            'hideReplies': false,
            'dateFormat': '%b/%d/%Y',
            'template': '{{date}} - {{tweet}}'
        }, options);
        var linking = function(tweet) {
            var parts = tweet.split(' ');
            var twit = '';
            for(var i = 0, len = parts.length; i < len; i++){
                var text = parts[i];
                var link = "https://twitter.com/#!/";
                if (text.indexOf('#') !== -1) text = '<a href="' + link + 'search/' + text.replace('#', '%23').replace(/[^A-Za-z0-9]/, '') + '" target="_blank">' + text + '</a>';
                if (text.indexOf('@') !== -1) text = '<a href="' + link + text.replace('@', '').replace(/[^A-Za-z0-9]/, '') + '" target="_blank">' + text + '</a>';
                if (text.indexOf('http://') !== -1) text = '<a href="' + text + '" target="_blank">' + text + '</a>';
                twit += text + ' ';
            }
            return twit;
        };
        var dating = function(twt_date) {
            var time = twt_date.split(' ');
            twt_date = new Date(Date.parse(time[1] + ' ' + time[2] + ', ' + time[5] + ' ' + time[3] + ' UTC'));
            var months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ];
            var _date = {
                '%d': twt_date.getDate(),
                '%m': twt_date.getMonth() + 1,
                '%b': months[twt_date.getMonth()].substr(0, 3),
                '%B': months[twt_date.getMonth()],
                '%y': String(twt_date.getFullYear()).slice(-2),
                '%Y': twt_date.getFullYear()
            };
            var date = settings.dateFormat;
            var format = settings.dateFormat.match(/%[dmbByY]/g);
            for(var i = 0, len = format.length; i < len; i++)date = date.replace(format[i], _date[format[i]]);
            return date;
        };
        var templating = function(data) {
            var temp = settings.template;
            var temp_variables = [
                'date',
                'tweet',
                'avatar'
            ];
            for(var i = 0, len = temp_variables.length; i < len; i++)temp = temp.replace(new RegExp('{{' + temp_variables[i] + '}}', 'gi'), data[temp_variables[i]]);
            return temp;
        };
        this.html('<span>Loading...</span>');
        var that = this;
        $1.getJSON('php/tweet.php', {
            count: settings.count,
            exclude_replies: settings.hideReplies
        }, function(twt) {
            that.find('span').fadeOut('fast', function() {
                that.html('<ul></ul>');
                for(var i = 0; i < settings.count; i++){
                    if (twt[i]) {
                        var temp_data = {
                            date: dating(twt[i].created_at),
                            tweet: linking(twt[i].text),
                            avatar: '<img src="' + twt[i].user.profile_image_url + '" />'
                        };
                        that.find('ul').append('<li>' + templating(temp_data) + '</li>');
                    } else break;
                }
            });
        });
    };
})(jQuery);
/**
* Maplace.js 0.1.2c
*
* Copyright (c) 2013 Daniele Moraschi
* Licensed under the MIT license
* For all details and documentation:
* http://maplacejs.com
*
* @version  0.1.2c
*/ (function($1, window1, google1, undefined1) {
    'use strict';
    var html_dropdown, html_ullist, Maplace;
    html_dropdown = {
        activateCurrent: function(index) {
            this.html_element.find('select').val(index);
        },
        getHtml: function() {
            var self = this, html = '', title, a;
            if (this.ln > 1) {
                html += '<select class="dropdown controls ' + this.o.controls_cssclass + '">';
                if (this.ShowOnMenu(this.view_all_key)) html += '<option value="' + this.view_all_key + '">' + this.o.view_all_text + '</option>';
                for(a = 0; a < this.ln; a += 1)if (this.ShowOnMenu(a)) html += '<option value="' + (a + 1) + '">' + (this.o.locations[a].title || '#' + (a + 1)) + '</option>';
                html += '</select>';
                html = $1(html).bind('change', function() {
                    self.ViewOnMap(this.value);
                });
            }
            title = this.o.controls_title;
            if (this.o.controls_title) title = $1('<div class="controls_title"></div>').css(this.o.controls_applycss ? {
                fontWeight: 'bold',
                fontSize: this.o.controls_on_map ? '12px' : 'inherit',
                padding: '3px 10px 5px 0'
            } : {}).append(this.o.controls_title);
            this.html_element = $1('<div class="wrap_controls"></div>').append(title).append(html);
            return this.html_element;
        }
    };
    html_ullist = {
        html_a: function(i, hash, ttl) {
            var self = this, index = hash || i + 1, title = ttl || this.o.locations[i].title, el_a = $1('<a data-load="' + index + '" id="ullist_a_' + index + '" href="#' + index + '" title="' + title + '"><span>' + (title || '#' + (i + 1)) + '</span></a>');
            el_a.css(this.o.controls_applycss ? {
                color: '#666',
                display: 'block',
                padding: '5px',
                fontSize: this.o.controls_on_map ? '12px' : 'inherit',
                textDecoration: 'none'
            } : {});
            el_a.on('click', function(e) {
                e.preventDefault();
                var i = $1(this).attr('data-load');
                self.ViewOnMap(i);
            });
            return el_a;
        },
        activateCurrent: function(index) {
            this.html_element.find('li').removeClass('active');
            this.html_element.find('#ullist_a_' + index).parent().addClass('active');
        },
        getHtml: function() {
            var html = $1("<ul class='ullist controls " + this.o.controls_cssclass + "'></ul>").css(this.o.controls_applycss ? {
                margin: 0,
                padding: 0,
                listStyleType: 'none'
            } : {}), title, a;
            if (this.ShowOnMenu(this.view_all_key)) html.append($1('<li></li>').append(html_ullist.html_a.call(this, false, this.view_all_key, this.o.view_all_text)));
            for(a = 0; a < this.ln; a++)if (this.ShowOnMenu(a)) html.append($1('<li></li>').append(html_ullist.html_a.call(this, a)));
            title = this.o.controls_title;
            if (this.o.controls_title) title = $1('<div class="controls_title"></div>').css(this.o.controls_applycss ? {
                fontWeight: 'bold',
                padding: '3px 10px 5px 0',
                fontSize: this.o.controls_on_map ? '12px' : 'inherit'
            } : {}).append(this.o.controls_title);
            this.html_element = $1('<div class="wrap_controls"></div>').append(title).append(html);
            return this.html_element;
        }
    };
    Maplace = function() {
        function Maplace(args) {
            this.VERSION = '0.1.2';
            this.errors = [];
            this.loaded = false;
            this.dev = true;
            this.markers = [];
            this.oMap = false;
            this.view_all_key = 'all';
            this.infowindow = null;
            this.ln = 0;
            this.oMap = false;
            this.oBounds = null;
            this.map_div = null;
            this.canvas_map = null;
            this.controls_wrapper = null;
            this.current_control = null;
            this.current_index = null;
            this.Polyline = null;
            this.Polygon = null;
            this.Fusion = null;
            this.directionsService = null;
            this.directionsDisplay = null;
            this.o = {
                map_div: '#gmap',
                controls_div: '#controls',
                generate_controls: true,
                controls_type: 'dropdown',
                controls_cssclass: '',
                controls_title: '',
                controls_on_map: true,
                controls_applycss: true,
                controls_position: google1.maps.ControlPosition.RIGHT_TOP,
                type: 'marker',
                view_all: true,
                view_all_text: 'View All',
                start: 0,
                locations: [],
                commons: {},
                map_options: {
                    mapTypeId: google1.maps.MapTypeId.ROADMAP,
                    zoom: 1
                },
                stroke_options: {
                    strokeColor: '#0000FF',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#0000FF',
                    fillOpacity: 0.4
                },
                directions_options: {
                    travelMode: google1.maps.TravelMode.DRIVING,
                    unitSystem: google1.maps.UnitSystem.METRIC,
                    optimizeWaypoints: false,
                    provideRouteAlternatives: false,
                    avoidHighways: false,
                    avoidTolls: false
                },
                styles: {},
                fusion_options: {},
                directions_panel: null,
                draggable: false,
                show_infowindows: true,
                show_markers: true,
                infowindow_type: 'bubble',
                listeners: {},
                beforeViewAll: function() {},
                afterViewAll: function() {},
                beforeShow: function(index, location, marker) {},
                afterShow: function(index, location, marker) {},
                afterCreateMarker: function(index, location, marker) {},
                beforeCloseInfowindow: function(index, location) {},
                afterCloseInfowindow: function(index, location) {},
                beforeOpenInfowindow: function(index, location, marker) {},
                afterOpenInfowindow: function(index, location, marker) {},
                afterRoute: function(distance, status, result) {},
                onPolylineClick: function(obj) {}
            };
            this.AddControl('dropdown', html_dropdown);
            this.AddControl('list', html_ullist);
            $1.extend(true, this.o, args);
        }
        Maplace.prototype.controls = {};
        Maplace.prototype.create_objMap = function() {
            var self = this, count = 0, i;
            for(i in this.o.styles)if (this.o.styles.hasOwnProperty(i)) {
                if (count === 0) this.o.map_options.mapTypeControlOptions = {
                    mapTypeIds: [
                        google1.maps.MapTypeId.ROADMAP
                    ]
                };
                count++;
                this.o.map_options.mapTypeControlOptions.mapTypeIds.push('map_style_' + count);
            }
            if (!this.loaded) try {
                this.map_div.css({
                    position: 'relative',
                    overflow: 'hidden'
                });
                this.canvas_map = $1('<div>').addClass('canvas_map').css({
                    width: '100%',
                    height: '100%'
                }).appendTo(this.map_div);
                this.oMap = new google1.maps.Map(this.canvas_map.get(0), this.o.map_options);
            } catch (err) {
                this.errors.push(err.toString());
            }
            else self.oMap.setOptions(this.o.map_options);
            count = 0;
            for(i in this.o.styles)if (this.o.styles.hasOwnProperty(i)) {
                count++;
                this.oMap.mapTypes.set('map_style_' + count, new google1.maps.StyledMapType(this.o.styles[i], {
                    name: i
                }));
                this.oMap.setMapTypeId('map_style_' + count);
            }
            this.debug('01');
        };
        Maplace.prototype.add_markers_to_objMap = function() {
            var a, type = this.o.type || 'marker';
            switch(type){
                case 'marker':
                    for(a = 0; a < this.ln; a++)this.create.marker.call(this, a);
                    break;
                default:
                    this.create[type].apply(this);
                    break;
            }
        };
        Maplace.prototype.create = {
            marker: function(index) {
                var self = this, point = this.o.locations[index], html = point.html || '', marker, a, point_infow, image_w, image_h, latlng = new google1.maps.LatLng(point.lat, point.lon), orig_visible = point.visible === false ? false : true;
                $1.extend(point, {
                    position: latlng,
                    map: this.oMap,
                    zIndex: 10000,
                    visible: this.o.show_markers === false ? false : orig_visible
                });
                if (point.image) {
                    image_w = point.image_w || 32;
                    image_h = point.image_h || 32;
                    $1.extend(point, {
                        icon: new google1.maps.MarkerImage(point.image, new google1.maps.Size(image_w, image_h), new google1.maps.Point(0, 0), new google1.maps.Point(image_w / 2, image_h / 2))
                    });
                }
                marker = new google1.maps.Marker(point);
                a = google1.maps.event.addListener(marker, 'click', function() {
                    self.o.beforeShow(index, point, marker);
                    point_infow = point.show_infowindows === false ? false : true;
                    if (self.o.show_infowindows && point_infow) self.open_infowindow(index, marker);
                    self.oMap.panTo(latlng);
                    point.zoom && self.oMap.setZoom(point.zoom);
                    if (self.current_control && self.o.generate_controls && self.current_control.activateCurrent) self.current_control.activateCurrent.call(self, index + 1);
                    self.current_index = index;
                    self.o.afterShow(index, point, marker);
                });
                this.oBounds.extend(latlng);
                this.markers.push(marker);
                this.o.afterCreateMarker(index, point, marker);
                point.visible = orig_visible;
                return marker;
            },
            polyline: function() {
                var self = this, a, latlng, path = [];
                for(a = 0; a < this.ln; a++){
                    latlng = new google1.maps.LatLng(this.o.locations[a].lat, this.o.locations[a].lon);
                    path.push(latlng);
                    this.create.marker.call(this, a);
                }
                $1.extend(this.o.stroke_options, {
                    path: path,
                    map: this.oMap
                });
                this.Polyline ? this.Polyline.setOptions(this.o.stroke_options) : this.Polyline = new google1.maps.Polyline(this.o.stroke_options);
            },
            polygon: function() {
                var self = this, a, latlng, path = [];
                for(a = 0; a < this.ln; a++){
                    latlng = new google1.maps.LatLng(this.o.locations[a].lat, this.o.locations[a].lon);
                    path.push(latlng);
                    this.create.marker.call(this, a);
                }
                $1.extend(this.o.stroke_options, {
                    paths: path,
                    editable: this.o.draggable,
                    map: this.oMap
                });
                this.Polygon ? this.Polygon.setOptions(this.o.stroke_options) : this.Polygon = new google1.maps.Polygon(this.o.stroke_options);
                google1.maps.event.addListener(this.Polygon, 'click', function(obj) {
                    self.o.onPolylineClick(obj);
                });
            },
            fusion: function() {
                $1.extend(this.o.fusion_options, {
                    styles: [
                        this.o.stroke_options
                    ],
                    map: this.oMap
                });
                this.Fusion ? this.Fusion.setOptions(this.o.fusion_options) : this.Fusion = new google1.maps.FusionTablesLayer(this.o.fusion_options);
            },
            directions: function() {
                var self = this, a, stopover, latlng, origin, destination, waypoints = [], distance = 0;
                for(a = 0; a < this.ln; a++){
                    latlng = new google1.maps.LatLng(this.o.locations[a].lat, this.o.locations[a].lon);
                    if (a === 0) origin = latlng;
                    else if (a === this.ln - 1) destination = latlng;
                    else {
                        stopover = this.o.locations[a].stopover === true ? true : false;
                        waypoints.push({
                            location: latlng,
                            stopover: stopover
                        });
                    }
                    this.create.marker.call(this, a);
                }
                $1.extend(this.o.directions_options, {
                    origin: origin,
                    destination: destination,
                    waypoints: waypoints
                });
                this.directionsService || (this.directionsService = new google1.maps.DirectionsService());
                this.directionsDisplay ? this.directionsDisplay.setOptions({
                    draggable: this.o.draggable
                }) : this.directionsDisplay = new google1.maps.DirectionsRenderer({
                    draggable: this.o.draggable
                });
                this.directionsDisplay.setMap(this.oMap);
                if (this.o.directions_panel) {
                    this.o.directions_panel = $1(this.o.directions_panel);
                    this.directionsDisplay.setPanel(this.o.directions_panel.get(0));
                }
                if (this.o.draggable) google1.maps.event.addListener(this.directionsDisplay, 'directions_changed', function() {
                    distance = self.compute_distance(self.directionsDisplay.directions);
                    self.o.afterRoute(distance);
                });
                this.directionsService.route(this.o.directions_options, function(result, status) {
                    if (status === google1.maps.DirectionsStatus.OK) {
                        distance = self.compute_distance(result);
                        self.directionsDisplay.setDirections(result);
                    }
                    self.o.afterRoute(distance, status, result);
                });
            }
        };
        Maplace.prototype.compute_distance = function(result) {
            var total = 0, i, myroute = result.routes[0], rlen = myroute.legs.length;
            for(i = 0; i < rlen; i++)total += myroute.legs[i].distance.value;
            return total;
        };
        Maplace.prototype.type_to_open = {
            bubble: function(location) {
                this.infowindow = new google1.maps.InfoWindow({
                    content: location.html || ''
                });
            }
        };
        Maplace.prototype.open_infowindow = function(index, marker) {
            this.CloseInfoWindow();
            var point = this.o.locations[index], type = point.type || this.o.infowindow_type;
            if (point.html && this.type_to_open[type]) {
                this.o.beforeOpenInfowindow(index, point, marker);
                this.type_to_open[type].call(this, point);
                this.infowindow.open(this.oMap, marker);
                this.o.afterOpenInfowindow(index, point, marker);
            }
        };
        Maplace.prototype.get_html_controls = function() {
            if (this.controls[this.o.controls_type] && this.controls[this.o.controls_type].getHtml) {
                this.current_control = this.controls[this.o.controls_type];
                return this.current_control.getHtml.apply(this);
            }
            return '';
        };
        Maplace.prototype.generate_controls = function() {
            if (!this.o.controls_on_map) {
                this.controls_wrapper.empty();
                this.controls_wrapper.append(this.get_html_controls());
                return;
            }
            var cntr = $1('<div class="on_gmap ' + this.o.controls_type + ' gmap_controls"></div>').css(this.o.controls_applycss ? {
                margin: '5px'
            } : {}), inner = $1(this.get_html_controls()).css(this.o.controls_applycss ? {
                background: '#fff',
                padding: '5px',
                border: '1px solid rgb(113,123,135)',
                boxShadow: 'rgba(0, 0, 0, 0.4) 0px 2px 4px',
                maxHeight: this.map_div.find('.canvas_map').outerHeight() - 80,
                minWidth: 100,
                overflowY: 'auto',
                overflowX: 'hidden'
            } : {});
            cntr.append(inner);
            this.oMap.controls[this.o.controls_position].push(cntr.get(0));
        };
        Maplace.prototype.init_map = function() {
            var self = this, i = 0;
            this.Polyline && this.Polyline.setMap(null);
            this.Polygon && this.Polygon.setMap(null);
            this.Fusion && this.Fusion.setMap(null);
            this.directionsDisplay && this.directionsDisplay.setMap(null);
            if (this.markers) {
                for(i in this.markers){
                    if (this.markers[i]) try {
                        this.markers[i].setMap(null);
                    } catch (err) {
                        self.errors.push(err);
                    }
                }
                this.markers.length = 0;
                this.markers = [];
            }
            if (this.o.controls_on_map && this.oMap.controls) this.oMap.controls[this.o.controls_position].forEach(function(element, index) {
                try {
                    self.oMap.controls[this.o.controls_position].removeAt(index);
                } catch (err) {
                    self.errors.push(err);
                }
            });
            this.oBounds = new google1.maps.LatLngBounds();
            this.debug('02');
        };
        Maplace.prototype.perform_load = function() {
            if (this.o.map_options.set_center) this.oMap.setCenter(new google1.maps.LatLng(this.o.map_options.set_center[0], this.o.map_options.set_center[1]));
            else if (this.ln === 1) {
                this.oMap.setCenter(this.markers[0].getPosition());
                this.ViewOnMap(1);
            } else if (this.ln === 0) {
                if (this.o.map_options.set_center) this.oMap.setCenter(new google1.maps.LatLng(this.o.map_options.set_center[0], this.o.map_options.set_center[1]));
                else this.oMap.fitBounds(this.oBounds);
                this.oMap.setZoom(this.o.map_options.zoom);
            } else {
                this.oMap.fitBounds(this.oBounds);
                if (typeof (this.o.start - 0) === 'number' && this.o.start > 0 && this.o.start <= this.ln) this.ViewOnMap(this.o.start);
                else this.ViewOnMap(this.view_all_key);
            }
        };
        Maplace.prototype.debug = function(msg) {
            if (this.dev && this.errors.length) console.log(msg + ': ', this.errors);
        };
        Maplace.prototype.AddControl = function(name, func) {
            if (!name || !func) return false;
            this.controls[name] = func;
            return true;
        };
        Maplace.prototype.CloseInfoWindow = function() {
            if (this.infowindow && (this.current_index || this.current_index === 0)) {
                this.o.beforeCloseInfowindow(this.current_index, this.o.locations[this.current_index]);
                this.infowindow.close();
                this.infowindow = null;
                this.o.afterCloseInfowindow(this.current_index, this.o.locations[this.current_index]);
            }
        };
        Maplace.prototype.ShowOnMenu = function(index) {
            if (index === this.view_all_key && this.o.view_all && this.ln > 1) return true;
            index = parseInt(index, 10);
            if (typeof (index - 0) === 'number' && index >= 0 && index < this.ln) {
                var visible = this.o.locations[index].visible === false ? false : true, on_menu = this.o.locations[index].on_menu === false ? false : true;
                if (visible && on_menu) return true;
            }
            return false;
        };
        Maplace.prototype.ViewOnMap = function(index) {
            if (index === this.view_all_key) {
                this.o.beforeViewAll();
                this.current_index = index;
                if (this.o.locations.length > 0 && this.o.generate_controls && this.current_control && this.current_control.activateCurrent) this.current_control.activateCurrent.apply(this, [
                    index
                ]);
                this.oMap.fitBounds(this.oBounds);
                this.CloseInfoWindow();
                this.o.afterViewAll();
            } else {
                index = parseInt(index, 10);
                if (typeof (index - 0) === 'number' && index > 0 && index <= this.ln) try {
                    google1.maps.event.trigger(this.markers[index - 1], 'click');
                } catch (err) {
                    this.errors.push(err.toString());
                }
            }
            this.debug('03');
        };
        Maplace.prototype.SetLocations = function(locs, reload) {
            this.o.locations = locs;
            reload && this.Load();
        };
        Maplace.prototype.AddLocations = function(locs, reload) {
            var self = this;
            if ($1.isArray(locs)) $1.each(locs, function(index, value) {
                self.o.locations.push(value);
            });
            if ($1.isPlainObject(locs)) this.o.locations.push(locs);
            reload && this.Load();
        };
        Maplace.prototype.AddLocation = function(location, index, reload) {
            var self = this;
            if ($1.isPlainObject(location)) this.o.locations.splice(index, 0, location);
            reload && this.Load();
        };
        Maplace.prototype.RemoveLocations = function(locs, reload) {
            var self = this, k = 0;
            if ($1.isArray(locs)) $1.each(locs, function(index, value) {
                if (value - k < self.ln) self.o.locations.splice(value - k, 1);
                k++;
            });
            else if (locs < this.ln) this.o.locations.splice(locs, 1);
            reload && this.Load();
        };
        Maplace.prototype.Loaded = function() {
            return this.loaded;
        };
        Maplace.prototype._init = function() {
            this.ln = this.o.locations.length;
            for(var i = 0; i < this.ln; i++){
                $1.extend(this.o.locations[i], this.o.commons);
                if (this.o.locations[i].html) {
                    this.o.locations[i].html = this.o.locations[i].html.replace('%index', i + 1);
                    this.o.locations[i].html = this.o.locations[i].html.replace('%title', this.o.locations[i].title || '');
                }
            }
            this.map_div = $1(this.o.map_div);
            this.controls_wrapper = $1(this.o.controls_div);
        };
        Maplace.prototype.Load = function(args) {
            $1.extend(true, this.o, args);
            args && args.locations && (this.o.locations = args.locations);
            this._init();
            this.o.visualRefresh === false ? google1.maps.visualRefresh = false : google1.maps.visualRefresh = true;
            this.init_map();
            this.create_objMap();
            this.add_markers_to_objMap();
            if (this.ln > 1 && this.o.generate_controls || this.o.force_generate_controls) {
                this.o.generate_controls = true;
                this.generate_controls();
            } else this.o.generate_controls = false;
            var self = this;
            if (!this.loaded) {
                google1.maps.event.addListenerOnce(this.oMap, 'idle', function() {
                    self.perform_load();
                });
                google1.maps.event.addListener(this.oMap, 'resize', function() {
                    self.canvas_map.css({
                        width: self.map_div.width(),
                        height: self.map_div.height()
                    });
                });
                var i;
                for(i in this.o.listeners){
                    var map = this.oMap, myListener = this.o.listeners[i];
                    if (this.o.listeners.hasOwnProperty(i)) google1.maps.event.addListener(this.oMap, i, function(event) {
                        myListener(map, event);
                    });
                }
            } else this.perform_load();
            this.loaded = true;
        };
        return Maplace;
    }();
    if (typeof define == 'function' && define.amd) define(function() {
        return Maplace;
    });
    else window1.Maplace = Maplace;
})(jQuery, this, google);
/**
 * @preserve Copyright 2011 Syd Lawrence ( www.sydlawrence.com ).
 * Version: 0.2
 *
 * Licensed under MIT and GPLv2.
 *
 * Usage: $('body').videoBG(options);
 *
 */ (function(e) {
    e.fn.videoBG = function(t, n) {
        if (e.fn.isMobileSafari()) return;
        if (!e.fn.canPositionFixed()) return;
        var n = {};
        if (typeof t == "object") n = e.extend({}, e.fn.videoBG.defaults, t);
        else if (!t) n = e.fn.videoBG.defaults;
        else return e(t).videoBG(n);
        var r = e(this);
        if (!r.length) return;
        if (r.css("position") == "static" || !r.css("position")) r.css("position", "relative");
        if (n.width == 0) n.width = r.width();
        if (n.height == 0) n.height = r.height();
        var i = e.fn.videoBG.wrapper();
        i.height(n.height).width(n.width);
        if (n.textReplacement) {
            n.scale = true;
            r.width(n.width).height(n.height).css("text-indent", "-9999px");
        } else i.css("z-index", n.zIndex + 1);
        i.html(r.html());
        var s = e.fn.videoBG.video(n);
        if (n.scale) {
            i.height(n.height).width(n.width);
            s.height(n.height).width(n.width);
        }
        r.html(i);
        r.append(s);
        return this;
    };
    e.fn.videoBG.video = function(t) {
        var n = e("<div/>");
        n.addClass("videoBG").css("position", t.position).css("z-index", t.zIndex).css("top", 0).css("left", 0).css("height", t.height).css("width", t.width).css("opacity", t.opacity).css("overflow", "hidden");
        var r = e("<video/>");
        r.css("position", "absolute").css("z-index", t.zIndex).attr("poster", t.poster).css("top", 0).css("left", 0).css("min-width", "100%").css("min-height", "100%");
        if (t.autoplay) r.attr("autoplay", t.autoplay);
        var i = r[0];
        if (t.loop) {
            loops_left = t.loop;
            r.bind("ended", function() {
                if (loops_left) i.play();
                if (loops_left !== true) loops_left--;
            });
        }
        r.bind("canplay", function() {
            if (t.autoplay) i.play();
        });
        if (e.fn.videoBG.supportsVideo()) {
            if (e.fn.videoBG.supportType("webm")) r.attr("src", t.webm);
            else if (e.fn.videoBG.supportType("mp4")) r.attr("src", t.mp4);
            else r.attr("src", t.ogv);
        }
        var s = e("<img/>");
        s.attr("src", t.poster).css("position", "absolute").css("z-index", t.zIndex).css("top", 0).css("left", 0).css("min-width", "100%").css("min-height", "100%");
        if (e.fn.videoBG.supportsVideo()) n.html(r);
        else n.html(s);
        if (t.scale) {
            n.css("height", "100%").css("width", "100%");
            r.css("height", "100%").css("width", "100%");
            s.css("height", "100%").css("width", "100%");
        }
        if (t.textReplacement) {
            n.css("min-height", 1).css("min-width", 1);
            r.css("min-height", 1).css("min-width", 1);
            s.css("min-height", 1).css("min-width", 1);
            n.height(t.height).width(t.width);
            r.height(t.height).width(t.width);
            s.height(t.height).width(t.width);
        }
        if (e.fn.videoBG.supportsVideo()) i.play();
        return n;
    };
    e.fn.videoBG.supportsVideo = function() {
        return document.createElement("video").canPlayType;
    };
    e.fn.videoBG.supportType = function(t) {
        if (!e.fn.videoBG.supportsVideo()) return false;
        var n = document.createElement("video");
        switch(t){
            case "webm":
                return n.canPlayType('video/webm; codecs="vp8, vorbis"');
            case "mp4":
                return n.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"');
            case "ogv":
                return n.canPlayType('video/ogg; codecs="theora, vorbis"');
        }
        return false;
    };
    e.fn.videoBG.wrapper = function() {
        var t = e("<div/>");
        t.addClass("videoBG_wrapper").css("position", "absolute").css("top", 0).css("left", 0);
        return t;
    };
    e.fn.videoBG.defaults = {
        mp4: "",
        ogv: "",
        webm: "",
        poster: "",
        autoplay: true,
        loop: 5,
        sclae: false,
        position: "absolute",
        opacity: 1,
        textReplacement: false,
        zIndex: 0,
        width: 0,
        height: 0
    };
})(jQuery);
$.fn.isMobileSafari = function() {
    return navigator.userAgent.match(/(iPod|iPhone|iPad)/);
};
$.fn.canPositionFixed = function() {
    var e = document.body;
    if (document.createElement && e && e.appendChild && e.removeChild) {
        var t = document.createElement("div");
        if (!t.getBoundingClientRect) return null;
        t.innerHTML = "x";
        t.style.cssText = "position:fixed;top:100px;";
        e.appendChild(t);
        var n = e.style.height, r = e.scrollTop;
        e.style.height = "3000px";
        e.scrollTop = 500;
        var i = t.getBoundingClientRect().top;
        e.style.height = n;
        var s = i === 100;
        e.removeChild(t);
        e.scrollTop = r;
        return s;
    }
    return null;
};

//# sourceMappingURL=repo.555a9710.js.map
